var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pega-login-container grid-y" }, [
    _c("div", { staticClass: "cell" }, [
      _c("div", { staticClass: "grid-x align-center" }, [
        _c(
          "div",
          { staticClass: "cell large-5 medium-8 small-10 pega-login-content" },
          [
            _vm._m(0),
            _vm._v(" "),
            _vm.error
              ? _c("validation-label", {
                  staticClass: "login-form-error",
                  attrs: { label: _vm.error, "data-test": "error-text" },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.login.apply(null, arguments)
                  },
                },
              },
              [
                _c("div", { staticClass: "form-group margin-bottom-1" }, [
                  _c(
                    "label",
                    {
                      staticClass: "boss-color-white",
                      attrs: { "data-test": "login-id" },
                    },
                    [_vm._v("ログインID：" + _vm._s(_vm.loginId))]
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "margin-0 pega-font-size-min-rem" }, [
                  _vm._v("\n            メールアドレス\n          "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email",
                      },
                    ],
                    attrs: {
                      name: "email",
                      autocomplete: "new-password",
                      type: "email",
                      placeholder: "メールアドレス",
                      "data-test": "email",
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "margin-0 pega-font-size-min-rem" }, [
                  _vm._v("\n            仮パスワード\n          "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.temporaryPassword,
                        expression: "temporaryPassword",
                      },
                    ],
                    attrs: {
                      name: "temporaryPassword",
                      autocomplete: "new-password",
                      type: "password",
                      placeholder: "仮パスワード",
                      "data-test": "temporary-password",
                    },
                    domProps: { value: _vm.temporaryPassword },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.temporaryPassword = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm.isRequiredAuthenticationCode
                  ? _c("div", { staticClass: "form-group" }, [
                      _c(
                        "p",
                        { staticClass: "margin-0 pega-font-size-min-rem" },
                        [_vm._v("\n              認証番号\n            ")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.authentication,
                            expression: "authentication",
                          },
                        ],
                        attrs: {
                          name: "authentication",
                          type: "number",
                          max: "9999",
                          min: "0",
                          placeholder: "認証番号",
                          "data-test": "authentication-code",
                        },
                        domProps: { value: _vm.authentication },
                        on: {
                          keypress: function ($event) {
                            return _vm.onlyNumberInRange($event, 9999)
                          },
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.authentication = $event.target.value
                          },
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "p",
                      { staticClass: "margin-0 pega-font-size-min-rem" },
                      [_vm._v("\n              新パスワード\n            ")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newPassword,
                          expression: "newPassword",
                        },
                      ],
                      class: {
                        "is-invalid-input login-form-error":
                          _vm.isInvalidPassword ||
                          _vm.isSameTemporaryAndNewPassword,
                      },
                      attrs: {
                        name: "newPassword",
                        type: "password",
                        placeholder: "新パスワード",
                        "data-test": "new-password",
                      },
                      domProps: { value: _vm.newPassword },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.newPassword = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.isInvalidPassword
                      ? _c("validation-label", {
                          staticClass: "login-form-error",
                          attrs: {
                            label:
                              "半角英数混在8文字以上20文字以内で入力してください。",
                            "data-test": "new-password-validation",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isSameTemporaryAndNewPassword
                      ? _c("validation-label", {
                          staticClass: "login-form-error",
                          attrs: {
                            label:
                              "仮パスワードと異なるものを入力してください。",
                            "data-test": "is-same-temporary-and-new-password",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "p",
                      { staticClass: "margin-0 pega-font-size-min-rem" },
                      [
                        _vm._v(
                          "\n              新パスワード（確認用）\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.confirmNewPassword,
                          expression: "confirmNewPassword",
                        },
                      ],
                      class: {
                        "is-invalid-input login-form-error":
                          _vm.isDifferentNewPassword,
                      },
                      attrs: {
                        name: "confirmNewPassword",
                        type: "password",
                        placeholder: "新パスワード（確認用）",
                        "data-test": "confirm-new-password",
                      },
                      domProps: { value: _vm.confirmNewPassword },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.confirmNewPassword = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.isDifferentNewPassword
                      ? _c("validation-label", {
                          staticClass: "login-form-error",
                          attrs: {
                            label:
                              "新パスワードと新パスワード(確認用)が一致しません。",
                            "data-test": "is-same-new-password-confirm",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "float-center boss-button-center pega-login-button pega-button",
                    attrs: {
                      disabled: _vm.isDisable,
                      type: "submit",
                      "data-test": "login-button",
                    },
                  },
                  [_vm._v("\n            ログイン\n          ")]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("div", { staticClass: "font-bold" }, [
        _vm._v("\n            正社員で長く働きたい女性のための転職サイト "),
        _c("span", { staticClass: "text-nowrap" }, [
          _vm._v("【女の転職タイプ】"),
        ]),
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "pega-logo margin-bottom-2",
        attrs: { src: require("@/assets/images/uki-logo.png") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }